import * as React from 'react'
import { Suspense } from 'react'

import Loading from 'modules/core/components/Loading'

interface CommentsTabProps {
  taskId: number
}

const CommentsTab = ({ taskId }: CommentsTabProps) => {
  const CommentsContent = React.useMemo(
    () =>
      React.lazy(() =>
        import('modules/tasks/components/TaskDetails/Comments').then((module) => ({
          default: module.Comments,
        }))
      ),
    []
  )

  return (
    <Suspense fallback={<Loading />}>
      <CommentsContent taskId={taskId} />
    </Suspense>
  )
}

export default CommentsTab
